import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from 'react-moment';
import ReactLoading from 'react-loading';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Form, Button, ProgressBar, ModalFooter } from "react-bootstrap"
import TablePagination from '@mui/material/TablePagination';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import '../../components/loader.css';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'


const Announcement = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [otherStates, setOtherState] = React.useState({ activePage: 1, rowsPerPage: 10, page: 0, total_count: 0, onload: true });
  const [state, setState] = React.useState([])
  const [filerstate, setfilterState] = React.useState({ status: null })
  const [addstate, setaddstate] = React.useState({
    title: "",
    announcement: "",
    start_date: "",
    end_date: "",
    image: null,
    link: ""
  })
  const [modalstate, setmodalstate] = React.useState(false)
  const [editstate, seteditstate] = React.useState({
    title: "",
    start_date: "",
    end_date: "",
    announcement: "",
    announcement_id: "",
    image_url: "",
    link: ""
  })

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
  const handleImageChange = (e) => {
    setaddstate({ ...addstate, image: e.target.files[0] });
  };

  const editImageChange = (e) => {
    seteditstate({ ...editstate, image: e.target.files[0] });
  };

  const handlePageChange = (event, newPage) => {
    // console.log("newpage",newPage)
    setOtherState({ ...otherStates, page: newPage })
    //console.log("newPage ", newPage);
    axios_get_api(newPage, true);

    // searchUser(state.searchValue,newPage)
  }
  const handleChangeRowsPerPage = (event, newPage) => {
    // console.log("event ", event);
    setOtherState({ ...otherStates, rowsPerPage: +event.target.value, page: 0 })

  }

  React.useEffect(() => {
    axios_get_api(0, true)
  }, [])
  const axios_get_api = (index = 0, onLoad) => {


    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/announcement_list`;
    let sendData = { dstatus: otherStates.dstatus, limit: otherStates.rowsPerPage, indexValue: index };
    if (filerstate.status != null) {
      sendData.status = filerstate.status
    }
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {

      console.log("response ", res);
      console.log("otherStates ", otherStates);
      if (index == 0 && onLoad) {
        setOtherState({ ...otherStates, total_count: res.data.dataCount })
      }
      setState(res.data.output)
    }).catch((e) => {
    });
  }

  const shipmentFilter = (e) => {
    console.log("e.target.value =", e)
    setfilterState({ ...filerstate, status: e })
  }

  React.useEffect(() => {
    axios_get_api(otherStates.page, true)
  }, [filerstate.status])

  const handleChange = (e) => {
    setaddstate({ ...addstate, [e.target.name]: e.target.value })
  }

  const edithandleChange = (e) => {
    seteditstate({ ...editstate, [e.target.name]: e.target.value })
  }


  const editAnnouncement = (announcement_id) => {
    if (editstate.start_date != "" && editstate.end_date != "") {
      const formData = new FormData();
      formData.append('announcement_id', announcement_id)
      formData.append('title', editstate.title);
      formData.append('start_date', editstate.start_date);
      formData.append('end_date', editstate.end_date);
      formData.append('announcement', editstate.announcement);
      formData.append('link', editstate.link);
      if (editstate.image) {
        formData.append('image', editstate.image);
      }

      let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/edit_announcement`;




      axios.post(full_api, formData, { headers: exportValue.headers, 'Content-Type': 'multipart/form-data' }).then((res) => {
        if (res.data.status == true) {
          setaddstate({ start_date: "", end_date: "", announcement: "", title: "", link: "", image_url: "" })
          Swal.fire({
            icon: 'success',
            title: 'Good Job...',
            text: 'Updated Successfully',

          })
          seteditstate({ start_date: "", end_date: "", announcement: "", announcement_id: "", title: "", link: "", image_url: "" })
          setmodalstate(false)
          axios_get_api(otherStates.page, true)
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something Went Wrong',

          })
        }

      }).catch((e) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something Went Wrong',

        })
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Fill Details',

      })
    }
  }
  const addAnnouncement = () => {
    if (addstate.start_date != "" && addstate.end_date != "") {
      const formData = new FormData();
      formData.append('title', addstate.title);
      formData.append('start_date', addstate.start_date);
      formData.append('end_date', addstate.end_date);
      formData.append('announcement', addstate.announcement);
      formData.append('link', addstate.link);
      if (addstate.image) {
        formData.append('image', addstate.image);
      }
      let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/create_announcement`;


      axios.post(full_api, formData, { headers: exportValue.headers, 'Content-Type': 'multipart/form-data' }).then((res) => {
        if (res.data.status == true) {
          setaddstate({
            announcement: "",
            start_date: "",
            end_date: "",
            image: null,
            link: ""
          })
          Swal.fire({
            icon: 'success',
            title: 'Good Job...',
            text: 'Added Successfully',

          })

          axios_get_api(otherStates.page, true)
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something Went Wrong',

          })
        }

      }).catch((e) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something Went Wrong',

        })
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Fill Details',

      })
    }
  }

  const updateAnnouncement = (status, announcement_id) => {
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/update_announcement_status`;
    let sendData = { status: status, announcement_id: announcement_id };

    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      if (res.data.status == true) {
        Swal.fire({
          icon: 'success',
          title: 'Good Job...',
          text: 'Updated Successfully',

        })
        axios_get_api(otherStates.page, true)
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something Went Wrong',

        })
      }

    }).catch((e) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something Went Wrong',

      })
    });

  }

  const removeAnnouncement = (status, announcement_id) => {
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/remove_announcement`;
    let sendData = { status: status, announcement_id: announcement_id };

    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      if (res.data.status == true) {
        Swal.fire({
          icon: 'success',
          title: 'Good Job...',
          text: 'Updated Successfully',

        })
        axios_get_api(otherStates.page, true)
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something Went Wrong',

        })
      }

    }).catch((e) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something Went Wrong',

      })
    });

  }
  const openEditModal = (item) => {
    setmodalstate(true)
    seteditstate({ start_date: item.start_date, end_date: item.end_date, announcement: item.announcement, announcement_id: item.announcement_id, title: item.title, link: item.link, image_url: item.image_url })
  }

  const closeModal = () => {
    setmodalstate(false)
    seteditstate({ start_date: "", end_date: "", announcement: "", announcement_id: "" })
  }

  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
        <Sub_header />
        <div class="row py-4">
          <div class="col-12 col-md">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                <li class="breadcrumb-item">
                  <a href="#">
                    <svg class="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                  </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Announcement</li>
              </ol>
            </nav>
            <h2 class="h4">All Announcement</h2>
          </div>
          <div class="col-12 col-md-5">

          </div>
          <div class="col-12 col-md text-end">
            <a href="#" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Announcement_box" data-bs-backdrop="false">Add Announcement</a>
          </div>
        </div>

        <div class="modal" id="Announcement_box" data-bs-backdrop="false">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Announcement Add</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Title:</label>
                  </div>
                  <div class="col-12 col-md">
                    <input type="text" class="form-control" name="title" required onChange={(e) => handleChange(e)} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Start Date:</label>
                  </div>
                  <div class="col-12 col-md">
                    <input type="date" class="form-control" name="start_date" required onChange={(e) => handleChange(e)} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">End Date:</label>
                  </div>
                  <div class="col-12 col-md">
                    <input type="date" class="form-control" name="end_date" required onChange={(e) => handleChange(e)} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Link:</label>
                  </div>
                  <div class="col-12 col-md">
                    <input type="url" class="form-control" name="link" onChange={(e) => handleChange(e)} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Image:</label>
                  </div>
                  <div class="col-12 col-md">
                    <input type="file" class="form-control" accept="image/*" onChange={handleImageChange} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Announcement:</label>
                  </div>
                  <div class="col-12 col-md">
                    <textarea class="form-control" rows="5" name="announcement" placeholder="Enter Announcement details" onChange={(e) => handleChange(e)}></textarea>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary" onClick={(e) => addAnnouncement(e)}>Create Announcement</button>
              </div>

            </div>
          </div>
        </div>

        <Modal show={modalstate} onHide={() => closeModal()}>
          <Modal.Header closeButton>
            <Modal.Title>Update Announcement</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <div class="modal-body">
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Title:</label>
                </div>
                <div class="col-12 col-md">
                  <input type="text" class="form-control" name="title" value={editstate.title} required onChange={(e) => edithandleChange(e)} />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Start Date:</label>
                </div>
                <div class="col-12 col-md">
                  <input type="date" class="form-control" name="start_date" value={editstate.start_date} required onChange={(e) => edithandleChange(e)} />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">End Date:</label>
                </div>
                <div class="col-12 col-md">
                  <input type="date" class="form-control" name="end_date" value={editstate.end_date} required onChange={(e) => edithandleChange(e)} />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Link:</label>
                </div>
                <div class="col-12 col-md">
                  <input type="url" class="form-control" name="link" value={editstate.link} onChange={(e) => edithandleChange(e)} />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Image:</label>
                </div>
                <div class="col-12 col-md">
                  <input type="file" class="form-control" accept="image/*" onChange={editImageChange} />
                  {editstate.image_url && (
                    <img src={`https://shiprocketcdn.fniix.com/customer_assets/${editstate.image_url}`} alt="Current" style={{ maxWidth: '100px', marginTop: '10px' }} />

                  )}
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label">Announcement:</label>
                </div>
                <div class="col-12 col-md">
                  <textarea class="form-control" rows="5" name="announcement" value={editstate.announcement} onChange={(e) => edithandleChange(e)}></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" onClick={(e) => editAnnouncement(editstate.announcement_id)}>Update Announcement</button>
            </div>
          </Modal.Body>
        </Modal>
        <section>
          <ul class="nav nav-tabs justify-content-end">
            <li>
              <a class={(filerstate.status == null) ? "nav-link active" : "nav-link"} onClick={() => shipmentFilter(null)}>All</a>
            </li>
            <li class="nav-item">
              <a class={(filerstate.status == 1) ? "nav-link active" : "nav-link"} onClick={() => shipmentFilter(1)}>Active</a>
            </li>
            <li class="nav-item">
              <a class={(filerstate.status == 0) ? "nav-link active" : "nav-link"} onClick={() => shipmentFilter(0)}>Inactive</a>
            </li>
          </ul>
        </section>
        <div class="card card-body border-0 shadow table-wrapper table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="border-gray-200">Title</th>
                <th class="border-gray-200">link</th>


                <th class="border-gray-200">Announcement</th>
                <th class="border-gray-200">Image</th>
                <th class="border-gray-200">Start Date</th>
                <th class="border-gray-200">End Date</th>
                <th class="border-gray-200">Status</th>
                <th class="border-gray-200">Action</th>
              </tr>
            </thead>
            <tbody>
              {state.map((item) => (
                <tr>
                  <td> {item.title}</td>
                  <td> {item.link}</td>

                  <td>
                    <span class="fw-normal"><a href="">
                      {item.announcement}
                    </a></span>
                  </td>
                  <td>{item.image_url != undefined && item.image_url != "" ? <img src={`https://shiprocketcdn.fniix.com/customer_assets/${item.image_url}`} width="50%" height="50%"></img> : ""}</td>
                  <td> {item.start_date}</td>
                  <td>{item.end_date}</td>
                  <td>{item.dstatus == 1 ? <span class="badge rounded-pill bg-success">Active</span> : <span class="badge rounded-pill bg-danger">Inactive</span>}</td>
                  <td>
                    <div class="btn-group">
                      <button class="btn btn-link text-dark dropdown-toggle dropdown-toggle-split m-0 p-0" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="icon icon-sm">
                          <span class="fa fa-ellipsis-h icon-dark"></span>
                        </span>
                        <span class="visually-hidden">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu py-0">
                        <a class="dropdown-item rounded-top" onClick={(e) => openEditModal(item)}><span class="fa fa-eye me-2"></span>View/Update</a>
                        {item.dstatus == 1 ? <a class="dropdown-item rounded-top" onClick={(e) => updateAnnouncement(0, item.announcement_id)}><span class="fa fa-eye-slash me-2"></span>Inactive</a> : <a class="dropdown-item rounded-top" onClick={(e) => updateAnnouncement(1, item.announcement_id)}><span class="fa fa-eye-slash me-2"></span>Active</a>
                        }
                        <a class="dropdown-item text-danger rounded-bottom" onClick={(e) => removeAnnouncement(0, item.announcement_id)}><span class="fa  fa-trash me-2"></span>Remove</a>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
          <TablePagination
            component="div"
            rowsPerPageOptions={[100, 150, 200, 250]}
            count={otherStates.total_count}
            page={otherStates.page}
            onPageChange={handlePageChange}
            rowsPerPage={otherStates.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}

          />
        </div>
      </section>
    </div>
  )
}

export default Announcement
